const THOUSAND = 1_000;
const TEN_THOUSAND = 10_000;

/**
 * Formats a product rating count for compact display.
 * - Below 1 000: plain number (e.g. 123)
 * - 1 000–9 999: one decimal + K (e.g. 1.2K)
 * - 10 000 and above: rounded thousands + K (e.g. 12K)
 */
export function formatRatingCount(
	ratingCount: string | number | null | undefined,
): string {
	const count = Number(ratingCount);
	if (!Number.isFinite(count) || count < 0) {
		return "0";
	}
	if (count < THOUSAND) {
		return String(count);
	}
	if (count < TEN_THOUSAND) {
		const valueInThousands = Math.round(count / 100) / 10;
		return `${valueInThousands.toFixed(1)}K`;
	}
	return `${Math.round(count / THOUSAND)}K`;
}
